import { Injectable, HostListener } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService {
    private screenWidth!: number;
    private screenHeight!: number;

    constructor() {
        this.getScreenSize();
    }

    @HostListener('window:resize', ['$event'])
    private getScreenSize(event?: Event): void {
        this.screenWidth = window.innerWidth;
        this.screenHeight = window.innerHeight;
    }

    public isMobile(): boolean {
        return this.screenWidth < 768;
    }

    public isTablet(): boolean {
        return this.screenWidth >= 768 && this.screenWidth < 1024;
    }

    public isDesktop(): boolean {
        return this.screenWidth >= 1024;
    }

    public getDeviceType(): string {
        if (this.isMobile()) {
            return 'mobile';
        } else if (this.isTablet()) {
            return 'tablet';
        } else {
            return 'desktop';
        }
    }

    public getScreenDimensions(): { width: number, height: number } {
        return {
            width: this.screenWidth,
            height: this.screenHeight
        };
    }
}
